import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Badge, Empty } from "@/components/admin/Ui";
import { Sparkle, ArrowUpRight } from "@phosphor-icons/react";

export default function Agents() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/agents/registry").then(({ data }) => setData(data));
  }, []);

  const agents = data?.agents || [];
  const runs = data?.recent_runs || [];

  return (
    <div data-testid="admin-agents-page">
      <PageHeader title="Autonomous workforce" subtitle="AI Agents · 9 live" />
      <div className="p-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <section className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {agents.map((a) => (
            <div key={a.key} className="bg-white border border-black/10 p-5 flex flex-col" data-testid={`agent-card-${a.key}`}>
              <div className="flex items-start justify-between">
                <Sparkle size={18} weight="duotone" className="text-ember" />
                <span className="text-[10px] uppercase tracking-widest text-navy/50">LIVE · {a.runs} RUNS</span>
              </div>
              <div className="font-display font-bold text-navy mt-3">{a.name}</div>
              <div className="text-[10px] uppercase tracking-widest text-navy/40 mt-1">{a.model}</div>
              <p className="mt-3 text-sm text-navy/70 leading-relaxed flex-1">{a.description}</p>
              <div className="mt-4 pt-3 border-t border-black/10 text-[10px] uppercase tracking-widest text-navy/40 flex items-center justify-between">
                <span>{a.last_run_at ? "Last: " + new Date(a.last_run_at).toLocaleString() : "Never run"}</span>
              </div>
            </div>
          ))}
        </section>

        <aside className="lg:col-span-4 bg-white border border-black/10">
          <div className="px-5 py-3 border-b border-black/10 flex items-center justify-between">
            <div className="overline">Recent agent runs</div>
            <Link to="/admin/activity" className="text-[10px] uppercase tracking-widest text-navy/50 hover:text-ember flex items-center gap-1">
              All <ArrowUpRight size={10} />
            </Link>
          </div>
          {runs.length === 0 ? <div className="p-5"><Empty label="No runs yet." /></div> : (
            <ul className="divide-y divide-black/10 max-h-[70vh] overflow-y-auto">
              {runs.map((r, i) => (
                <li key={i} className="px-5 py-3" data-testid={`agent-run-${i}`}>
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-navy text-sm">{r.agent}</span>
                    <Badge tone={r.status === "success" ? "green" : "red"}>{r.status}</Badge>
                  </div>
                  <div className="text-[10px] text-navy/50 mt-1 flex items-center justify-between">
                    <span>{r.model} · {r.total_tokens} tok</span>
                    <span>${(r.cost_usd || 0).toFixed(4)}</span>
                  </div>
                  <div className="text-[10px] text-navy/40 mt-0.5">{new Date(r.ts).toLocaleString()}</div>
                </li>
              ))}
            </ul>
          )}
        </aside>
      </div>
    </div>
  );
}
